import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { merge } from 'rxjs';
import { EVENT_BUS } from '@shared/domain/tokens/event-bus.token';
import { ServiceDrawerAddedEvent } from '@platform/event-bus/domain/events/service-drawer.event';
import { SERVICE_STATE_SERVICE } from '@features/service/domain/tokens/service-state.token';
import { ServiceDrawerRemovedEvent, ServiceDrawerChangedEvent } from '@platform/event-bus/domain/events/service-drawer.event';


@Injectable({ providedIn: 'root' })
export class ServiceDrawerSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);
  private readonly serviceStateService = inject(SERVICE_STATE_SERVICE);

  constructor() {
    merge(
      this.eventBus.ofType(ServiceDrawerAddedEvent),
      this.eventBus.ofType(ServiceDrawerRemovedEvent)
    ).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      const currentDrawer = this.serviceStateService.getCurrentDrawer();

      const exists = this.serviceStateService.getAllDrawers().some(drawer => drawer.id === currentDrawer?.id);

      if (!exists) {
        this.eventBus.publish(new ServiceDrawerChangedEvent());
      }
    });
  }
}
